<template>
  <div class="relative" ref="triggerRef">
    <!-- Bouton déclencheur -->
    <button
      @click="toggleDropdown"
      class="text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 rounded-full p-1 transition-colors"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      aria-label="Actions pour le client"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
      </svg>
    </button>

    <!-- Menu déroulant (Teleporté au body) -->
    <teleport to="body">
      <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <div
          v-if="isOpen"
          ref="menuRef"
          class="fixed w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-[9999]"
          :style="menuStyle"
          role="menu"
          aria-orientation="vertical"
          tabindex="-1"
        >
          <div class="py-1" role="none">
            <!-- Action: Envoyer e-mail -->
            <button
              @click="triggerAction('open-email')"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex items-center gap-2"
              role="menuitem"
            >
              <span>✉️</span> Envoyer e-mail
            </button>

            <!-- Action: Gérer crédits -->
            <button
              @click="triggerAction('open-credits')"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex items-center gap-2"
              role="menuitem"
            >
              <span>💳</span> Gérer photos
            </button>

            <!-- Action: Générer lien de réinitialisation -->
            <button
              @click="triggerAction('open-password-reset')"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex items-center gap-2"
              role="menuitem"
            >
              <span>🔐</span> Générer lien reset
            </button>

            <!-- Action: Vérifier infos client -->
            <!-- <button
              @click="triggerAction('open-client-info')"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex items-center gap-2"
              role="menuitem"
            >
              <span>ℹ️</span> Vérifier infos client
            </button> -->
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'RowActions',
  props: {
    client: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      menuStyle: {
        top: '0px',
        left: '0px'
      }
    };
  },
  methods: {
    toggleDropdown(event) {
      // Stop propagation pour éviter les conflits de clic immédiats
      if (event) event.stopPropagation();
      
      if (this.isOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    },
    openDropdown() {
      this.calculatePosition();
      this.isOpen = true;

      // Ajouter les écouteurs
      this.$nextTick(() => {
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('keydown', this.handleEsc);
        window.addEventListener('scroll', this.closeDropdown, true); // true pour capture (scroll dans n'importe quel conteneur)
        window.addEventListener('resize', this.closeDropdown);
      });
    },
    closeDropdown() {
      this.isOpen = false;
      this.removeListeners();
    },
    calculatePosition() {
      const triggerEl = this.$refs.triggerRef;
      if (!triggerEl) return;

      const rect = triggerEl.getBoundingClientRect();
      
      // Positionner en bas à droite du déclencheur par défaut
      // Ajustement: 48px (largeur menu approximative) ou aligné à droite
      // Pour un menu de width 12rem (w-48 = 192px)
      const MENU_WIDTH = 192;
      const PAGE_MARGIN = 10;

      let left = rect.right - MENU_WIDTH;
      let top = rect.bottom + 5; // 5px de marge

      // Vérifier si ça sort à gauche
      if (left < PAGE_MARGIN) {
        left = PAGE_MARGIN;
      }

      // Vérifier si ça sort en bas (optionnel, ici on laisse natif)
      
      this.menuStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    },
    handleClickOutside(event) {
      // Si on clique en dehors du menu ET du déclencheur
      const menuEl = this.$refs.menuRef;
      const triggerEl = this.$refs.triggerRef;
      
      if (menuEl && !menuEl.contains(event.target) && triggerEl && !triggerEl.contains(event.target)) {
        this.closeDropdown();
      }
    },
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    },
    removeListeners() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEsc);
      window.removeEventListener('scroll', this.closeDropdown, true);
      window.removeEventListener('resize', this.closeDropdown);
    },
    triggerAction(actionName) {
      this.$emit(actionName, this.client);
      this.closeDropdown();
    }
  },
  beforeUnmount() {
    this.removeListeners();
  }
};
</script>
